const viewedGameIdCache = new Set<string>();

export function clearGameViewedCache(): void {
  viewedGameIdCache.clear();
}

export function markGameViewedInCache(gameId: string): void {
  const trimmed = gameId.trim();
  if (trimmed) {
    viewedGameIdCache.add(trimmed);
  }
}

export function isGameViewedInCache(gameId: string): boolean {
  return viewedGameIdCache.has(gameId);
}
